module.exports = __webpack_public_path__ + "assets/img/24-s.b7fc2aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/24-s.jpg
// module id = fwNT
// module chunks = 0